import { ModalContextType } from '@/contexts/modalContext';
import { Modal } from 'app-components';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import CapitalizedButton from '../components/common/CapitalizedButton';

interface IModalProps extends ModalContextType {}

export default function PendingAppModal({ closeModal }: IModalProps) {
    function onClose(e) {
        e?.preventDefault();
        closeModal('pendingAppModal');
    }

    return (
        <Modal id="pendingAppModal">
            <Modal.Header id="pendingAppModalHeader" titleId="indportal.pendingAppModal.header" onHide={onClose} />
            <Modal.Body id="pendingAppModalBody">
                <FormattedMessage 
                    id="indportal.pendingAppModal.body"
                    values={{
                        strong: chunks => <strong>{chunks}</strong>
                    }}
                />
            </Modal.Body>
            <Modal.Controls>
                <CapitalizedButton 
                    id="pendingAppModalCancelButton" 
                    onClickHandler={onClose} 
                    variant="secondary" 
                    labelId="button.cancel" 
                />
            </Modal.Controls>
        </Modal>
    );
}
